import { createRouter, createWebHashHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    redirect:'/login',
  },
  {
    path:'/mainpage',
    name:'mainpage',
    component:() => import('../views/Mainpage/index.vue'),
    meta:{title:'主页',},
    redirect:'/mainpage/AssetStatistics',
    children:[
      {
        path:'AssetStatistics',
        name:'AssetStatistics',
        component:() => import('../views/AssetStatistics/index.vue'),
        meta:{title:'当前资产统计',icon:"icon-dangqianzichantongji",requiresAuth:true},
      },
      {
        path:'AssetDetailed',
        name:'AssetDetailed',
        component:() => import('../views/AssetDetailed/index.vue'),
        meta:{title:'当前资产明细',icon:"icon-dangqianzichanmingxi",requiresAuth:true},
      },
      {
        path:'Income',
        name:'Income',
        component:() => import('../views/Income/index.vue'),
        meta:{title:'收益',icon:"icon-shouyi",requiresAuth:true},
      },
      {
        path:'RechargeStatistics',
        name:'RechargeStatistics',
        component:() => import('../views/RechargeStatistics/index.vue'),
        meta:{title:'充值统计',icon:"icon-chongzhitongji",requiresAuth:true},
      },
      {
        path:'ResourceManagement',
        name:'ResourceManagement',
        component:() => import('../views/ResourceManagement/index.vue'),
        meta:{title:'资源包管理',icon:"icon-ziyuanbaoguanli",requiresAuth:true},
      },
    ]
  },
  {
    path:'/login',
    name:'login',
    component: () => import('../views/Login/index.vue'),
    meta:{title:'登录',}
  },
  {
    path:'/forgetpass',
    name:'forgetpass',
    component:() => import('../views/ResPass/index.vue'),
    meta:{title:'忘记密码',}
  },
  {
    path:'/replacephone',
    name:'replacephone',
    component:() => import('../views/ReplacePhone/index.vue'),
    meta:{title:'替换手机',}
  },

]

const router = createRouter({
  history: createWebHashHistory(),
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth === true) {
    const token = localStorage.getItem('token');
    if (token) {
      next()
    } else {
      return next({ path: "/login" })
    }
  } else {
    next()
  }

})
export default router
